import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const WelcomeScreenFigure: React.FC<SvgProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="960"
        height="635"
        viewBox="0 0 960 635"
        fill="none"
        className={className}
    >
        <path
            d="M699.035 3.2002C752.742 3.20026 801.392 16.6084 844.975 43.4541H844.976C888.663 70.3369 923.365 106.557 949.134 152.072H949.135C974.894 197.563 987.8 249.667 987.8 306.417C987.8 363.155 974.869 414.428 949.129 460.247L949.128 460.249C925.725 501.96 894.82 535.695 856.635 561.687L854.354 563.239L855.554 565.724L984.976 833.8H-955.621C-1110.86 833.8 -1236.8 707.758 -1236.8 552.271V3.2002H699.035Z"
            stroke="white"
            stroke-width="6.4"
        />
    </svg>
);

export default WelcomeScreenFigure;
